module.exports = __webpack_public_path__ + "static/media/seo.8b77c145.svg";